import type { PackageStateType } from './types';

export const operatorDTO = (data: unknown): PackageStateType['operator'] => {
  if (data && typeof data === 'object') {
    return {
      id: 'id' in data && typeof data.id === 'number' ? data.id : 0,
      name: 'name' in data && typeof data.name === 'string' ? data.name : '',
      logo: 'logo' in data && typeof data.logo === 'string' ? data.logo : '',
    };
  }

  return null;
};
